import { FunctionComponent, useState } from 'react'

import { IFind } from 'shared/modules/termosUso/domain/usecases/Find'
import Steps from 'shared/components/Steps'
import { IStepsData } from 'shared/components/Steps/StepsComponent.types'

import { IValidateCnpj } from '../../domain/usecases/ValidateCnpjImpl'
import { IVerifyPhoneAndCnpj } from '../../domain/usecases/VerifyPhoneAndCnpjImpl'
import { IConsultZipCode } from '../../domain/usecases/ConsultZipCodeImpl'
import { ICreateFrotista } from '../../domain/usecases/CreateFrotistaImpl'
import { ISendPin } from '../../domain/usecases/SendPinImpl'
import { IValidateAntt } from '../../domain/usecases/ValidateAnttImpl'
import { IValidateEmail } from '../../domain/usecases/ValidateEmailImpl'
import { IVerifyPin } from '../../domain/usecases/VerifyPinImpl'
import { IValidateEmailByCode } from '../../domain/usecases/ValidateEmailByCodeImpl'

import Antt from './components/Antt'
import CepAddress from './components/CepAddress'
import Cnpj from './components/Cnpj'
import Email from './components/Email'
import EmailConfirm from './components/EmailConfirm'
import Phone from './components/Phone'
import Photo from './components/Photo'
import Terms from './components/Terms'
import NewPassword from './components/NewPassword'
import { Container } from './styles'

type TProps = {
  validateEmail: IValidateEmail
  validateEmailByCode: IValidateEmailByCode
  sendPin: ISendPin
  verifyPin: IVerifyPin
  consultZipCode: IConsultZipCode
  createFrotistaImpl: ICreateFrotista
  findTerms: IFind
  validateAntt: IValidateAntt
  validateCnpjImpl: IValidateCnpj
  verifyPhoneAndCnpj: IVerifyPhoneAndCnpj
}

export const steps = {
  Terms: 0,
  Email: 1,
  EmailConfirm: 2,
  Phone: 3,
  Cnpj: 4,
  Photo: 5,
  CepAddress: 6,
  Antt: 7,
  NewPassword: 8,
}

const SignUp: FunctionComponent<TProps> = ({
  validateEmail,
  validateEmailByCode,
  sendPin,
  verifyPin,
  consultZipCode,
  createFrotistaImpl,
  findTerms,
  validateAntt,
  validateCnpjImpl,
  verifyPhoneAndCnpj,
}) => {
  const [selectedStep, setSelectedStep] = useState(steps.Terms)

  const components: IStepsData[] = [
    {
      component: (
        <Terms
          key="terms"
          setSelectedStep={setSelectedStep}
          findTerms={findTerms}
        />
      ),
    },
    {
      component: (
        <Email
          key="email"
          setSelectedStep={setSelectedStep}
          validateEmail={validateEmail}
        />
      ),
    },
    {
      component: (
        <EmailConfirm
          validateEmailByCode={validateEmailByCode}
          setSelectedStep={setSelectedStep}
          validateEmail={validateEmail}
        />
      ),
    },
    {
      component: (
        <Phone
          key="phone"
          setSelectedStep={setSelectedStep}
          sendPin={sendPin}
          verifyPhoneAndCnpj={verifyPhoneAndCnpj}
          verifyPin={verifyPin}
        />
      ),
    },
    {
      component: (
        <Cnpj
          key="cnpj"
          setSelectedStep={setSelectedStep}
          validateCnpj={validateCnpjImpl}
        />
      ),
    },
    {
      component: <Photo key="photo" setSelectedStep={setSelectedStep} />,
    },
    {
      component: (
        <CepAddress
          key="cep"
          setSelectedStep={setSelectedStep}
          consultZipCode={consultZipCode}
        />
      ),
    },
    {
      component: (
        <Antt
          key="antt"
          setSelectedStep={setSelectedStep}
          validateAnttImpl={validateAntt}
        />
      ),
    },
    {
      component: (
        <NewPassword
          key="password"
          setSelectedStep={setSelectedStep}
          createFrotistaImpl={createFrotistaImpl}
        />
      ),
    },
  ]

  return (
    <Container key="signUpKey">{components[selectedStep]?.component}</Container>
  )
}

export default SignUp
